import includes from "lodash/fp/includes";

import { FORM_COMPONENTS } from "utils/constants";

// Used to stop FieldSelector from rendering a field if it has no options to choose from.
export default function fieldHasNoOptionsToRender({
  component,
  filteredOptions,
  fields,
}) {
  const componentsThatUseFilteredOptions = [
    FORM_COMPONENTS.BUTTON_OPTIONS,
    FORM_COMPONENTS.ICON_BUTTON_OPTIONS,
    FORM_COMPONENTS.BUTTON_WITH_IMAGE_OPTIONS,
    FORM_COMPONENTS.GROUPED_BUTTON_OPTIONS,
    FORM_COMPONENTS.GROUPED_ICON_BUTTON_OPTIONS,
    FORM_COMPONENTS.DROP_DOWN,
    FORM_COMPONENTS.DROP_DOWN_WITH_DETAILS,
  ];

  // check setOfGroupedOptionsComponent, which doesn't have options but instead fields array
  if (
    component === FORM_COMPONENTS.SET_OF_GROUPED_ICON_BUTTON_OPTIONS &&
    fields.length === 0
  ) {
    return true;
  }

  // Check the rest of components
  if (
    filteredOptions.length === 0 &&
    includes(component)(componentsThatUseFilteredOptions)
  ) {
    return true;
  }
  return false;
}
